<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="pageTitle">Kemitraan</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" class="mb-3" v-if="loading.app == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 50px"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <router-link
                            :to="{ name: 'referral.index' }"
                            class="col-6 text-left balance-action"
                        >
                            <span class="title">Kode Affiliate</span>
                            <h1 class="total truncate-text">
                                <span>{{ customer.affiliate_id }}</span>
                            </h1>
                        </router-link>
                        <router-link
                            :to="{ name: 'referral.komisi' }"
                            class="col-6 text-left balance-action"
                        >
                            <span class="title">Komisi</span>
                            <h1 class="total">
                                <span>Rp {{ customer.komisi | rupiah }}</span>
                            </h1>
                        </router-link>
                    </div>
                    <!-- <div class="wallet-footer">
                        <a
                            href="https://blog.qiosfin.com/update-program-agen-affiliate-agen-affiliate-plus-di-qiosfin/"
                            target="_blank"
                            class="btn btn-primary btn-block"
                        >
                            Pelajari tentang Agen Affiliate disini!
                        </a>
                    </div> -->
                </div>
            </div>

            <div class="section inset" style="margin-top: 50px">
                <div class="order-menu p-0 m-0">
                    <h4 style="font-weight: bold" class="mb-0">
                        Agen Affiliate
                        <label
                            class="badge badge-warning mb-0 pr-2 pl-2"
                            v-if="customer.affiliate_type == 'PLUS'"
                            style="font-weight: bold; margin-left: 3px"
                            >Plus
                            <img
                                :src="require('@/assets/shines.png')"
                                height="60%"
                                style="margin-left: 3px"
                        /></label>
                    </h4>
                    <span style="font-size: 12px"
                        >Kelola Downline dan Komisi dari Program Agen Affiliate
                    </span>
                    <hr style="margin-top: 5px" />
                    <div class="menu">
                        <div class="item" style="flex: none">
                            <router-link :to="{ name: 'referral.downline' }">
                                <img
                                    :src="
                                        require('@/assets/icon_menu/list_downline.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Downline</span></strong
                                >
                            </router-link>
                        </div>
                        <div class="item" style="flex: none">
                            <router-link :to="{ name: 'referral.komisi' }">
                                <img
                                    :src="
                                        require('@/assets/icon_menu/tarik_komisi.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Komisi</span></strong
                                >
                            </router-link>
                        </div>
                        <div class="item" style="flex: none">
                            <router-link
                                :to="{ name: 'referral.target.index' }"
                            >
                                <img
                                    :src="
                                        require('@/assets/icon_menu/target.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Target Affiliate</span></strong
                                >
                            </router-link>
                        </div>
                        <div class="item" style="flex: none">
                            <router-link
                                :to="{ name: 'referral.leader-board.index' }"
                            >
                                <img
                                    :src="
                                        require('@/assets/icon_menu/leaderboard.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    ><span>Leader Board</span></strong
                                >
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Information Verification -->
        <action-sheet
            ref="information_verification"
            :title="'Informasi'"
            :inset="false"
        >
            <div class="text-center">
                <img
                    :src="require('@/assets/verification_rejected.png')"
                    alt="Verifikasi dalam proses"
                    class="w-50"
                /><br />
            </div>
            <div class="text-center p-2">
                <h3 class="mb-0">Anda belum melengkapi data diri</h3>
                <p class="mb-0">Yuk, segera langkapi sekarang</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block"
                    @click="hideInformationVerification(true)"
                >
                    Lengkapi Data Diri
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="hideInformationVerification(false)"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'account.upgrade',
        data() {
            return {
                loading: {
                    dialog: false,
                    app: true,
                },
            };
        },
        created() {
            this.loading.app = false;
            if (Object.keys(this.setting).length == 0) {
                this.loading.app = true;
                this.getSetting()
                    .then(() => {
                        this.loading.app = false;
                    })
                    .catch(() => {
                        this.loading.app = false;
                    });
            }
        },
        computed: {
            ...mapState(['customer', 'setting', 'toast', 'VUE_ENV']),
        },
        methods: {
            ...mapActions(['getSetting', 'getCustomer', 'coming']),
            checkAccountVerification() {
                if (
                    this.customer.account_verified_data == null ||
                    this.customer.account_verified_data.status != 'APPROVED'
                ) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
<style>
    a.balance-action {
        position: relative; /* Pastikan elemen ini memiliki posisi relatif */
        padding-right: 40px; /* Berikan ruang tambahan di sebelah kanan untuk ikon */

        &:after {
            content: '\f3d1';
            font-family: 'Ionicons';
            font-size: 10px;
            position: absolute;
            right: 10px; /* Sesuaikan jarak dari kanan */
            color: white; /* Warna ikon menjadi putih */
            background-color: #f39c12; /* Warna latar belakang lingkaran */
            border-radius: 50%; /* Membuat latar belakang menjadi lingkaran */
            width: 20px; /* Lebar lingkaran */
            height: 20px; /* Tinggi lingkaran */
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 1; /* Pastikan opacity penuh */
            line-height: 1em;
            top: 60%;
            margin-top: -15px; /* Sesuaikan margin-top untuk posisi vertikal */
        }
    }
    .truncate-text {
        white-space: nowrap; /* Mencegah teks melompat ke baris baru */
        overflow: hidden; /* Menyembunyikan teks yang melebihi container */
        text-overflow: ellipsis; /* Menambahkan ... di akhir teks yang terpotong */
        max-width: 100%; /* Sesuaikan dengan lebar maksimal yang diinginkan */
    }
</style>
